import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import { INSTALLATION_TYPES } from 'dashboard/constants/installationTypes';
import { frontendURL } from '../../../helper/URLHelper';

import OnixPageRouteView from './pages/OnixPageRouteView.vue';
import FlowsIndex from './flows/Index.vue';
import FlowCanvasPage from './flows/Canvas.vue';
import KnowledgeExplorerPage from './knowledge/Index.vue';
import KnowledgeShowPage from './knowledge/Show.vue';
import ActionsPage from './actions/Index.vue';
import ActionFormPage from './actions/Form.vue';
import TestCenterPage from './test/Index.vue';

const meta = {
  permissions: ['administrator', 'agent'],
  featureFlag: FEATURE_FLAGS.ONIX,
  installationTypes: [
    INSTALLATION_TYPES.CLOUD,
    INSTALLATION_TYPES.ENTERPRISE,
    INSTALLATION_TYPES.COMMUNITY,
  ],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/onix'),
    component: OnixPageRouteView,
    redirect: to => ({
      name: 'onix_flows_index',
      params: to.params,
    }),
    children: [
      {
        path: frontendURL('accounts/:accountId/onix/flows'),
        name: 'onix_flows_index',
        component: FlowsIndex,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/flows/:flowId'),
        name: 'onix_flow_canvas',
        component: FlowCanvasPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/knowledge'),
        name: 'onix_knowledge_index',
        component: KnowledgeExplorerPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/knowledge/:collectionId'),
        name: 'onix_knowledge_show',
        component: KnowledgeShowPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/actions'),
        name: 'onix_actions_index',
        component: ActionsPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/actions/new'),
        name: 'onix_actions_new',
        component: ActionFormPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/actions/:actionId'),
        name: 'onix_actions_edit',
        component: ActionFormPage,
        meta,
      },
      {
        path: frontendURL('accounts/:accountId/onix/test'),
        name: 'onix_test_index',
        component: TestCenterPage,
        meta,
      },
    ],
  },
];
